import { sendAnalytics } from '@playcastdotio/Analytics';
import type {
  PlaycastAnalyticsHostEnteredMatchmakingPool,
  PlaycastAnalyticsHostExitedMatchmakingPool,
  PlaycastAnalyticsInstallEmailSent,
  PlaycastAnalyticsHostSoftKicked,
  PlaycastAnalyticsSwitchCampaignRequested,
  PlaycastAnalyticsSwitchCampaignSuccess,
  PlaycastAnalyticsSwitchCampaignFailed,
  PlaycastAnalyticsInviteCreated,
} from '@playcastdotio/Analytics';

export const sessionFlowMethods = {

  // ── Matchmaking Pool ──

  sendHostEnteredMatchmakingPoolEvent(): void {
    sendAnalytics({ name: 'Host Entered Matchmaking Pool', role: 'host', tier2Filters: ['machine'] } as PlaycastAnalyticsHostEnteredMatchmakingPool);
  },

  sendHostExitedMatchmakingPoolEvent(): void {
    sendAnalytics({ name: 'Host Exited Matchmaking Pool', role: 'host', tier2Filters: ['machine'] } as PlaycastAnalyticsHostExitedMatchmakingPool);
  },

  // ── Install ──

  sendInstallEmailSentEvent(email: string): void {
    sendAnalytics({ name: 'Install Email Sent', role: 'host', tier2Filters: ['machine'], source: 'electron', email } as PlaycastAnalyticsInstallEmailSent);
  },

  // ── Kicks ──

  sendHostSoftKickedEvent(): void {
    sendAnalytics({ name: 'Host Soft Kicked', role: 'host', tier2Filters: ['machine'] } as PlaycastAnalyticsHostSoftKicked);
  },

  // ── Campaign Switch ──

  sendSwitchCampaignRequestedEvent(params: {
    campaignId: string;
    previousCampaignId?: string;
    reason: string;
    gameName: string;
    launcher: string;
  }): void {
    sendAnalytics({
      name: 'Switch Campaign Requested',
      role: 'host',
      tier2Filters: ['machine'],
      campaignId: params.campaignId,
      previousCampaignId: params.previousCampaignId ?? 'none',
      reason: params.reason,
      gameName: params.gameName,
      launcher: params.launcher,
    } as PlaycastAnalyticsSwitchCampaignRequested);
  },

  sendSwitchCampaignSuccessEvent(params: {
    campaignId: string;
    previousCampaignId?: string;
    gameName: string;
  }): void {
    sendAnalytics({
      name: 'Switch Campaign Success',
      role: 'host',
      tier2Filters: ['machine'],
      campaignId: params.campaignId,
      previousCampaignId: params.previousCampaignId ?? 'none',
      gameName: params.gameName,
    } as PlaycastAnalyticsSwitchCampaignSuccess);
  },

  sendSwitchCampaignFailedEvent(params: {
    campaignId: string;
    previousCampaignId?: string;
    reason: string;
    gameName: string;
    launcher: string;
  }): void {
    sendAnalytics({
      name: 'Switch Campaign Failed',
      role: 'host',
      tier2Filters: ['machine'],
      campaignId: params.campaignId,
      previousCampaignId: params.previousCampaignId ?? 'none',
      reason: params.reason,
      gameName: params.gameName,
      launcher: params.launcher,
    } as PlaycastAnalyticsSwitchCampaignFailed);
  },

  // ── Invite ──

  sendInviteCreatedEvent(params: {
    invitationId: string;
    inviteType: 'copy link' | 'email' | 'sms';
  }): void {
    sendAnalytics({
      name: 'Invite Created',
      role: 'host',
      tier2Filters: ['machine'],
      invitationId: params.invitationId,
      inviteType: params.inviteType,
    } as PlaycastAnalyticsInviteCreated);
  },
};

export type SessionFlowMethods = typeof sessionFlowMethods;
